module.exports = __webpack_public_path__ + "img/Shifting investments from fossil fuels in Southeast Asia.2ea10b44.png";